import {Injectable} from '@angular/core';
import {BaseService} from "../../services/_base.service";
import { HttpResponse } from "@angular/common/http";
import { PaginatedItems } from '../../models/types';
import { ScheduledTask } from '../../models/scheduled-task.model';
import { Observable, scheduled } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScheduledTasksService extends BaseService {
  params = [
    'run_at', 'job_class', 'payload', 'run_now'
  ];

  index(
    job_class: string,
    pageIndex: number = 1,
    pageSize: number = 10,
    filters: Record<string, any>,
    sort: string,
  ): Observable<HttpResponse<PaginatedItems<ScheduledTask>>> {
    return this.http.get<PaginatedItems<ScheduledTask>>(
      `${this.adminURL}/scheduled_tasks`,
      this.getParams({
        job_class,
        page: pageIndex,
        page_size: pageSize,
        ...filters,
        sort,
      }),
    );
  }

  create(value) {
    return this.http.post(`${this.adminURL}/scheduled_tasks/`, {
      scheduled_task: this.permitParams(value, ...this.params),
    }, this.getParams());
  }

  cancel(task_id: number) {
    return this.http.delete(`${this.adminURL}/scheduled_tasks/${task_id}/cancel`, this.getParams());
  }

  runNow(task_id: number) {
    return this.http.post(`${this.adminURL}/scheduled_tasks/${task_id}/run_now`, {}, this.getParams());
  }
}
